import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b2adb74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scorecard-topics",
  "aria-label": "Scorecard topics"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["aria-describedby"]
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  class: "topic--score--current-score",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 1,
  class: "loading-topics"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-reader-only" }, "Loading scorecard...", -1))

import { ref, type Ref, computed, type ComputedRef, nextTick } from 'vue'
import { useStore } from 'vuex'
import Button from 'primevue/button'
import Skeleton from 'primevue/skeleton'
import Popover from 'primevue/popover'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faChartColumn } from 'fontawesome/pro-regular-svg-icons'
import {
    getDiffVariant,
    getDiffIcon,
    getAriaScoreDesc,
} from '@/utils/frontlineManagerDash'
import { formatScoreWithPercentage } from '@/utils/number'
import DashboardCard from '@/components/FrontlineManagerDash/DashboardCard.vue'

interface Props {
    scorecards: Scorecard[]
    loading: boolean
    metric: string
    timePeriod: string
    csatAsPercent: boolean
    isFiveScore: boolean
    decimals: {
        nps: number
        csat: number
        fivestar: number
        ces: number
    }
    showError?: boolean
    onReloadClick?: Function
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Scorecard',
  props: {
    scorecards: {},
    loading: { type: Boolean },
    metric: {},
    timePeriod: {},
    csatAsPercent: { type: Boolean },
    isFiveScore: { type: Boolean },
    decimals: {},
    showError: { type: Boolean },
    onReloadClick: { type: Function }
  },
  setup(__props: any) {

const props = __props

const store = useStore()

const popover = ref()
const scorecardList: Ref<HTMLElement | undefined> = ref()
const formatScorecardName = (scorecard: Scorecard) => {
    let scorecardName = scorecard?.name ?? ''

    if (!props.loading && scorecardName) {
        if (scorecardName.toLowerCase().endsWith(' scorecard')) {
            return scorecardName
        }

        if (scorecard?.isScorecard) {
            return `${scorecardName} Scorecard`
        }

        return scorecardName
    }
    return 'Scorecard'
}

const selectedScorecardId: ComputedRef<number> = computed(
    () => store.getters['frontlineManagerDash/selectedScorecardId'] ?? 0
)
const selectedScorecard: ComputedRef<Scorecard | undefined> = computed(() => {
    if (!props.scorecards?.length) return undefined
    return (
        props.scorecards.find((s) => s.id === selectedScorecardId.value) ??
        props.scorecards?.[0]
    )
})

const selectNewScorecard = (scorecardId: number) => {
    store.commit('frontlineManagerDash/setSelectedScorecardId', scorecardId)
    popover.value.hide()
}

const togglePopover = (event) => {
    popover.value.toggle(event)
}

const focusOnMenu = () => {
    nextTick(() => {
        scorecardList.value?.querySelector('button')?.focus()
    })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.loading || _ctx.showError || _ctx.scorecards?.length > 0)
    ? (_openBlock(), _createBlock(DashboardCard, {
        key: 0,
        title: formatScorecardName(selectedScorecard.value),
        icon: _unref(faChartColumn),
        "response-count": selectedScorecard.value?.responseCount ?? 0,
        "aria-busy": _ctx.loading,
        "show-error": _ctx.showError,
        "on-reload-click": _ctx.onReloadClick
      }, _createSlots({
        content: _withCtx(() => [
          (!_ctx.loading && _ctx.scorecards.length)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedScorecard.value.topics, (topic) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: topic.id,
                    class: "topic"
                  }, [
                    _createElementVNode("dt", {
                      id: `topic--name-${topic.id}`,
                      class: "topic--name"
                    }, _toDisplayString(topic.name), 9, _hoisted_2),
                    _createElementVNode("dd", {
                      class: "topic--score",
                      "aria-describedby": `aria-score-desc-${topic.id}`
                    }, [
                      _createElementVNode("span", {
                        id: `aria-score-desc-${topic.id}`,
                        class: "screen-reader-only"
                      }, _toDisplayString(_unref(getAriaScoreDesc)(
                                    topic.selectedPeriodScore,
                                    topic.changeSinceLastPeriod,
                                    _ctx.timePeriod,
                                    _ctx.metric
                                )), 9, _hoisted_4),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatScoreWithPercentage)(
                                    topic.selectedPeriodScore,
                                    _ctx.isFiveScore,
                                    _ctx.csatAsPercent,
                                    _ctx.metric,
                                    _ctx.decimals
                                )), 1),
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: _unref(getDiffIcon)(topic.changeSinceLastPeriod),
                        class: _normalizeClass([
                                'topic--score--icon',
                                `topic--score--icon__${_unref(getDiffVariant)(topic.changeSinceLastPeriod)}`,
                            ]),
                        "aria-hidden": "true"
                      }, null, 8, ["icon", "class"]),
                      _createElementVNode("div", {
                        class: _normalizeClass([
                                'topic--score--prev-score',
                                `topic--score--prev-score__${_unref(getDiffVariant)(topic.changeSinceLastPeriod)}`,
                            ]),
                        "aria-hidden": "true"
                      }, _toDisplayString(_unref(formatScoreWithPercentage)(
                                    topic.changeSinceLastPeriod,
                                    _ctx.isFiveScore,
                                    _ctx.csatAsPercent,
                                    _ctx.metric,
                                    _ctx.decimals
                                )), 3)
                    ], 8, _hoisted_3)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (column) => {
                  return _createElementVNode("div", {
                    key: column,
                    class: "loading-topics--column"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (row) => {
                      return _createElementVNode("div", {
                        key: row,
                        class: "loading-topics--column--row"
                      }, [
                        _createVNode(_unref(Skeleton), {
                          "data-testid": "loading-skeleton",
                          width: "50%",
                          height: "18px",
                          "border-radius": "100px"
                        }),
                        _createVNode(_unref(Skeleton), {
                          "data-testid": "loading-skeleton",
                          width: "25%",
                          height: "18px",
                          "border-radius": "100px"
                        })
                      ])
                    }), 64))
                  ])
                }), 64))
              ]))
        ]),
        _: 2
      }, [
        (!_ctx.loading && _ctx.scorecards?.length > 1)
          ? {
              name: "header",
              fn: _withCtx(() => [
                _createVNode(_unref(Button), {
                  id: "select-scorecard-popover-button",
                  variant: "text",
                  icon: "pi pi-chevron-down",
                  "aria-label": "Select Scorecard",
                  size: "large",
                  "aria-haspopup": "menu",
                  "aria-controls": "scorecard-popover",
                  onClick: togglePopover
                }),
                _createVNode(_unref(Popover), {
                  id: "scorecard-popover",
                  ref_key: "popover",
                  ref: popover,
                  dt: { contentPadding: 0 },
                  onShow: focusOnMenu
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", {
                      id: "select-scorecard-list",
                      ref_key: "scorecardList",
                      ref: scorecardList,
                      role: "menu",
                      "aria-label": "Scorecard list"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scorecards, (scorecard) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: scorecard.id,
                          class: "select-scorecard-list-item",
                          role: "menuitem"
                        }, [
                          _createVNode(_unref(Button), {
                            class: "select-new-scorecard-button",
                            label: formatScorecardName(scorecard),
                            icon: 
                                scorecard.id === selectedScorecard.value?.id
                                    ? 'pi pi-check'
                                    : undefined
                            ,
                            variant: "text",
                            severity: "secondary",
                            "icon-pos": "right",
                            "icon-size": "large",
                            onClick: ($event: any) => (selectNewScorecard(scorecard.id))
                          }, null, 8, ["label", "icon", "onClick"])
                        ]))
                      }), 128))
                    ], 512)
                  ], undefined, true),
                  _: 1
                }, 512)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title", "icon", "response-count", "aria-busy", "show-error", "on-reload-click"]))
    : _createCommentVNode("", true)
}
}

})